<template>
  <div>
    <section class="registerbox " style="padding-bottom: 13px" align="right">
          <a  @click="refresh" title="Refresh">  <span class="icon is-medium" >
      <span class="fa fa-refresh" id="refreshId" >
        </span>
      </span></a>
        </section>
        <div class="table-responsive" id="searchlisting">
            <table class="table table-striped table-bordered" border="1" >
                <thead>
                    <tr v-if="data.length>0" >
                      <th>Delivery Agent Name</th>
                      <th>Pickup Pending</th>
                      <th>Total ofd</th>
                      <th>Handover Pending</th>
                      <th>Total rto</th>
                      <th>Total Delivered</th>
                      <th>Cod Collectable</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="value in data">
                      <td> {{ value.daname }}</td>
                      <td> {{ value.pickuppending }}</td>
                      <td> {{ value.totalofd }}</td>
                      <td> {{ value.handoverpending }}</td>
                      <td> {{ value.totalrto }}</td>
                      <td> {{ value.totaldelivered }}</td>
                      <td> {{ value.codcollectable }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
      </div>
    </template>
<script>
import CONSTANTS from '@/utils/constants'
import Filters from '@/utils/filters'
import Utils from '@/utils'
export default {
  data: function() {
    return {
      name: 'deliveryStatusReport',
      data: []
    }
  },
  created: function () {
    this.displaydata()
  },
  methods: {
    refresh: function () {
      document.getElementById('refreshId').className = 'fa-spin fa fa-refresh'
      this.displaydata()
    },
    displaydata: function () {
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      const customerGetobj = {
        deliveryagentpincode: `${userInfo.pickuplocationpincode}`
      }
      this.$http.post(`${CONSTANTS.API_URL}/ConsignmentMaster.svc/GellAllDAPendingStatus`, customerGetobj)
        .then((result) => {
          if (result.body.returnmsg === 'Successful') {
            this.data = result.body.returnvalue
            document.getElementById('refreshId').className = 'fa fa-refresh'
          } else {
            alert('No records found')
          }
        })
        .catch((ex) => {
          console.log('error-----', ex)
        })
    }
  }
}
</script>

<style lang="css">
.table tr th{
  color:#fff!important;
}

/*.table button{
  background:	#B0C4DE!important;
  color:#000!important;
}*/
.table tr:hover{
  background:#efefef;
}

tbody tr:nth-child(even) {background: #f2f2f2}
tbody tr:nth-child(odd) {background: #FFF}

.registerbox {
  margin-top:30px;
  margin-left: auto;
  margin-right: auto;
  width: 1159px;
  background-color: #fff;
}
hr {
  margin-bottom: 0px;
}
</style>
